/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import useListenSize from '../hooks/useListenSize';
import useApi from '../hooks/useApi';
import SubmitButton from '../components/SubmitButton';
import ErrorHandling from '../components/ErrorHandling';
import { sendError } from '../redux/actions';

// eslint-disable-next-line no-shadow
function BlockedVerificationCode() {
  const { request, response, loading, error } = useApi();
  const {
    handleSubmit,
    register,
    formState: { errors, isValid },
  } = useForm({ mode: 'onChange', reValidateMode: 'onChange' });
  const history = useHistory();
  useListenSize();

  const dispatch = useDispatch();
  const store = useSelector(state => ({
    phone: state.contact?.phone,
    phoneWithMask: state.contact?.phoneWithMask,
  }));

  const onSubmit = async () => {
    const loginRequest = await request.loginRequest({ phone: store.phone });
    if (loginRequest) {
      dispatch(sendError(false));
      history.push({ pathname: '/', search: '?reference=blockedSMS' });
    }
  };

  return (
    <div className="k-content-wrapper">
      <ErrorHandling response={response} error={error} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <section className="k-info">
          <h1>
            Verification code could not be sent to <span className="k-primary">{store.phoneWithMask}</span>
          </h1>
          <p>
            You previously requested to stop receiving SMS, but we need to send you a six-digit code so you can verify
            your identity.
          </p>
          <section className="k-form k-form-indent">
            <div className="k-checkbox animate__animated animate__fadeInDown">
              <label htmlFor="confirmUnblockVerificationCode">
                <input
                  type="checkbox"
                  id="confirmUnblockVerificationCode"
                  name="confirmUnblockVerificationCode"
                  {...register('confirmUnblockVerificationCode', { required: 'This is required' })}
                />
                I have reactivated SMS by texting &quot;START&quot; to 91948
              </label>
            </div>
            <div className="k-form-validation-message">
              {errors.confirmUnblockVerificationCode && errors.confirmUnblockVerificationCode.message}
            </div>
            <div className="k-submit k-error-button">
              <SubmitButton text="Resend Code" color={!isValid && '#DCDCDC'} loading={loading} />
            </div>
          </section>
        </section>
      </form>
    </div>
  );
}

export default BlockedVerificationCode;
